<div class="dashboard-container">
    <!-- Header section -->
    <div class="flex items-center justify-between mb-4">
        <h2 class="text-xl font-semibold text-gray-800">Historique d'ouverture de caisse</h2>
        <div class="flex gap-2">
            <!-- Loading Indicator next to the refresh button -->
            <div *ngIf="isLoading" class="flex items-center text-blue-600 mr-3 text-sm font-medium">
                <i class="fa fa-circle-notch fa-spin mr-2"></i> Chargement...
            </div>
            <button (click)="loadHistory()" [disabled]="isLoading"
                class="flex items-center gap-2 px-3 py-1.5 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 transition text-sm disabled:opacity-50">
                <i class="fa fa-sync-alt"></i>
                <span>Actualiser</span>
            </button>
        </div>
    </div>

    <!-- Summary Cards -->
    <div class="stats-grid">
        <div class="stats-card">
            <div class="stats-icon"><i class="fa fa-list-ul text-blue-500"></i></div>
            <div class="stats-info">
                <h4>{{stats.total}}</h4>
                <p>Total Ouvertures</p>
            </div>
        </div>
        <div class="stats-card">
            <div class="stats-icon"><i class="fa fa-calendar-day text-green-500"></i></div>
            <div class="stats-info">
                <h4>{{stats.today}}</h4>
                <p>Aujourd'hui</p>
            </div>
        </div>
        <div class="stats-card">
            <div class="stats-icon"><i class="fa fa-shopping-cart text-purple-500"></i></div>
            <div class="stats-info">
                <h4>{{stats.withOrder}}</h4>
                <p>Avec Commandes</p>
            </div>
        </div>
        <div class="stats-card">
            <div class="stats-icon"><i class="fa fa-keyboard text-orange-500"></i></div>
            <div class="stats-info">
                <h4>{{stats.shortcuts}}</h4>
                <p>Raccourcis F8</p>
            </div>
        </div>
        <div class="stats-card">
            <div class="stats-icon"><i class="fa fa-bolt text-amber-500"></i></div>
            <div class="stats-info">
                <h4>{{stats.virtual}}</h4>
                <p>Commandes Virtuelles</p>
            </div>
        </div>
    </div>

    <!-- Main section -->
    <div class="orders-section relative">
        <!-- Filters row -->
        <div class="controls-bar">
            <div class="filters">
                <div class="search-box">
                    <input type="search" [(ngModel)]="filterUser" (input)="onFilterChange()"
                        placeholder="Rechercher par utilisateur">
                </div>
                <select [(ngModel)]="filterType" (change)="onFilterChange()" class="status-select">
                    <option value="">Tous les types</option>
                    <option value="WITH_ORDER">Avec Commande</option>
                    <option value="WITHOUT_ORDER">Sans Commande</option>
                </select>
                <select [(ngModel)]="filterOrigin" (change)="onFilterChange()" class="status-select">
                    <option value="">Toutes les origines</option>
                    <option value="BUTTON">Bouton Manuel</option>
                    <option value="SHORTCUT">Raccourci F8</option>
                    <option value="ORDER_CREATION">Création Commande</option>
                    <option value="ORDER_VALIDATION">Validation Commande</option>
                </select>
                <div class="flex items-center gap-2">
                    <input type="date" [(ngModel)]="startDate" (change)="onFilterChange()" class="date-picker">
                    <span class="text-gray-400">-</span>
                    <input type="date" [(ngModel)]="endDate" (change)="onFilterChange()" class="date-picker">
                </div>
                <button (click)="resetFilters()" class="px-2 text-gray-400 hover:text-blue-600 transition">
                    <i class="fa fa-undo"></i>
                </button>
            </div>
        </div>

        <!-- Table content -->
        <div class="orders-container relative" style="min-height: 300px;">
            <table class="orders-table desktop-view">
                <thead>
                    <tr>
                        <th>Date &amp; Heure</th>
                        <th>Type</th>
                        <th>Origine</th>
                        <th>Utilisateur</th>
                        <th>Montant</th>
                        <th>Commande</th>
                        <th>Statut</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="isLoading">
                        <td colspan="8" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let j of displayedJournals" [class.d-none]="isLoading" [class.opacity-50]="isBeingDeleted(j.id!)"
                        [class.bg-red-50]="isBeingDeleted(j.id!)">
                        <td>
                            <div class="flex flex-col">
                                <span class="font-medium text-gray-700">{{ j.timestamp | date:'dd/MM/yyyy' }}</span>
                                <span class="text-xs text-gray-400">{{ j.timestamp | date:'HH:mm:ss' }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="flex flex-col gap-1">
                                <span class="status-badge" [class.paid]="j.type === 'WITH_ORDER'"
                                    [class.unpaid]="j.type === 'WITHOUT_ORDER'">
                                    {{ j.type === 'WITH_ORDER' ? 'Commande' : 'Libre' }}
                                </span>
                                <span *ngIf="j.orderId || j.linkedOrderIds"
                                    class="px-2 py-0.5 rounded text-[10px] font-bold text-center border"
                                    [ngClass]="j.isOrderVirtual ? 'bg-purple-50 text-purple-700 border-purple-100' : 'bg-green-50 text-green-700 border-green-100'">
                                    {{ j.isOrderVirtual ? 'VIRTUEL' : 'RÉEL' }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="flex items-center gap-2 text-sm text-gray-600">
                                <i class="fa w-4 text-center text-gray-400" [ngClass]="getOriginIcon(j.origin)"></i>
                                <span>{{ getOriginLabel(j.origin) }}</span>
                            </div>
                        </td>
                        <td>
                            <div class="flex items-center gap-2">
                                <div class="client-avatar">{{ (j.username || 'U').substring(0, 2).toUpperCase() }}</div>
                                <span class="text-gray-700 font-medium">{{ j.username }}</span>
                            </div>
                        </td>
                        <td>
                            <span *ngIf="j.amount" class="text-blue-600 font-bold">
                                {{ j.amount | number:'1.2-2' }} MAD
                            </span>
                            <span *ngIf="!j.amount" class="text-gray-300">-</span>
                        </td>
                        <td>
                            <button *ngIf="j.orderId" (click)="goToOrderDetails(j.orderId)"
                                class="px-2 py-0.5 bg-blue-50 text-blue-700 hover:bg-blue-100 border border-blue-100 rounded text-xs font-bold transition">
                                #{{ j.orderId }}
                            </button>
                            <div *ngIf="j.linkedOrderIds" class="flex flex-wrap gap-1 mt-1">
                                <button *ngFor="let id of j.linkedOrderIds.split(',')" (click)="goToOrderDetails(+id)"
                                    class="px-1.5 py-0.5 bg-amber-50 text-amber-700 hover:bg-amber-100 border border-amber-100 rounded text-[10px] font-bold transition">
                                    #{{ id }}
                                </button>
                            </div>
                            <span *ngIf="!j.orderId && !j.linkedOrderIds" class="text-gray-300">-</span>
                        </td>
                        <td>
                            <div class="flex flex-col text-xs">
                                <span *ngIf="j.reconciliationStatus"
                                    class="px-2 py-0.5 rounded-full text-[10px] font-bold text-center" [ngClass]="{
                                        'bg-gray-100 text-gray-600': j.reconciliationStatus === 'PENDING',
                                        'bg-green-100 text-green-700': j.reconciliationStatus === 'MATCHED',
                                        'bg-blue-100 text-blue-700': j.reconciliationStatus === 'MANUAL',
                                        'bg-red-100 text-red-700': j.reconciliationStatus === 'UNMATCHED'
                                    }">
                                    {{ j.reconciliationStatus }}
                                </span>
                                <span class="text-gray-500 mt-1 italic">{{ j.reason }}</span>
                            </div>
                        </td>
                        <!-- Admin actions (only for F8 entries with amount) -->
                        <td>
                            <div *ngIf="isF8Entry(j)" class="flex gap-1">
                                <button (click)="openEditDialog(j)" title="Modifier ce F8"
                                    class="px-1.5 py-0.5 bg-blue-50 text-blue-600 border border-blue-200 rounded text-xs hover:bg-blue-100 transition">
                                    <i class="fa fa-pen"></i>
                                </button>
                                <button (click)="askDeleteConfirm(j.id!)" title="Supprimer ce F8"
                                    class="px-1.5 py-0.5 bg-red-50 text-red-600 border border-red-200 rounded text-xs hover:bg-red-100 transition">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                            <span *ngIf="!isF8Entry(j)" class="text-gray-300 text-xs">-</span>
                        </td>
                    </tr>
                    <tr *ngIf="displayedJournals.length === 0 && !isLoading">
                        <td colspan="8" class="text-center py-5 text-gray-400">
                            <i class="fa fa-inbox block text-4xl mb-2"></i>
                            Aucun résultat trouvé
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- ─── PAGINATION CONTROLS ────────────────────────────────────────── -->
        <div class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-100 rounded-b-xl" *ngIf="totalElements > 0">
            <div class="text-sm text-gray-500">
                Affichage de <span class="font-medium text-gray-700">{{ (currentPage * pageSize) + 1 }}</span> à 
                <span class="font-medium text-gray-700">{{ (currentPage * pageSize) + displayedJournals.length }}</span> sur 
                <span class="font-medium text-gray-700">{{ totalElements }}</span> entrées
            </div>
            
            <div class="flex items-center gap-2">
                <button (click)="prevPage()" [disabled]="currentPage === 0 || isLoading"
                    class="px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition">
                    <i class="fa fa-chevron-left mr-1"></i> Précédent
                </button>
                
                <span class="text-sm font-medium text-gray-700 bg-gray-100 px-3 py-1 rounded">
                    Page {{ currentPage + 1 }} / {{ totalPages }}
                </span>
                
                <button (click)="nextPage()" [disabled]="currentPage >= totalPages - 1 || isLoading"
                    class="px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-50 border border-gray-200 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition">
                    Suivant <i class="fa fa-chevron-right ml-1"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- ─── Edit F8 Modal ─────────────────────────────────────────────────── -->
    <div *ngIf="editingF8" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div class="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md mx-4 relative">

            <!-- Loader overlay while saving -->
            <div *ngIf="isLoading"
                class="absolute inset-0 bg-white bg-opacity-80 flex flex-col items-center justify-center rounded-xl z-10">
                <div class="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-3"></div>
                <span class="text-sm text-blue-600 font-medium">Enregistrement en cours...</span>
            </div>

            <div class="flex items-center justify-between mb-4">
                <h3 class="text-lg font-bold text-gray-800">
                    <i class="fa fa-pen text-blue-500 mr-2"></i>Modifier F8 #{{ editingF8.id }}
                </h3>
                <button (click)="closeEditDialog()" [disabled]="isLoading"
                    class="text-gray-400 hover:text-gray-600 disabled:opacity-40">
                    <i class="fa fa-times text-xl"></i>
                </button>
            </div>

            <!-- Warning if reconciled -->
            <div *ngIf="editingF8.reconciliationStatus === 'MATCHED' || editingF8.reconciliationStatus === 'MANUAL'"
                class="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-700">
                <i class="fa fa-exclamation-triangle mr-2"></i>
                Ce F8 est déjà réconcilié. La modification va <strong>annuler la réconciliation</strong>
                et relancer l'analyse automatiquement.
            </div>

            <div class="space-y-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Montant (MAD)</label>
                    <input type="number" [(ngModel)]="editAmount" step="0.01" min="0"
                        class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300">
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Raison</label>
                    <input type="text" [(ngModel)]="editReason"
                        class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        placeholder="Raison de l'ouverture...">
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Commentaire</label>
                    <textarea [(ngModel)]="editComment" rows="2"
                        class="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300"
                        placeholder="Commentaire optionnel..."></textarea>
                </div>
            </div>

            <div class="flex gap-3 mt-5 justify-end">
                <button (click)="closeEditDialog()" [disabled]="isLoading"
                    class="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition disabled:opacity-40">
                    Annuler
                </button>
                <button (click)="saveEditF8()" [disabled]="isLoading"
                    class="px-4 py-2 text-sm text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition disabled:opacity-50 flex items-center gap-2">
                    <i class="fa fa-save"></i>
                    Enregistrer
                </button>
            </div>
        </div>
    </div>

    <!-- ─── Delete F8 Confirmation Dialog ────────────────────────────────── -->
    <app-confirmation-dialog [isVisible]="showDeleteConfirm" title="Supprimer ce F8"
        message="Cette action va annuler la réconciliation associée (si elle existe) et relancer l'analyse automatiquement. Confirmer la suppression ?"
        confirmText="Supprimer" cancelText="Annuler" type="danger" (confirm)="confirmDelete()" (cancel)="cancelDelete()"
        (close)="cancelDelete()">
    </app-confirmation-dialog>
</div>